export const PLAN_LABELS = {
  BASIC: "Básico",
  PLUS: "Plus",
  PRO: "Pro",
  ENTERPRISE: "Enterprise"
}

export const FEATURE_REQUIREMENTS = {
  advancedReports: {
    requiredPlan: "PLUS",
    planFlag: "allowAdvancedReports",
    title: "Reportes avanzados",
    bullets: [
      "Forecast semanal y mensual",
      "Saturación operativa",
      "Mapa de ocupación",
      "Lecturas ejecutivas avanzadas"
    ]
  },
  financialExecutive: {
    requiredPlan: "PLUS",
    planFlag: "allowAdvancedReports",
    title: "Finanzas ejecutivas",
    bullets: [
      "Producción vs cobro",
      "CxC, aging y cartera",
      "Desempeño por doctor",
      "Métodos de pago y exportación ejecutiva"
    ]
  },
  billingAdvanced: {
    requiredPlan: "PLUS",
    planFlag: "allowAdvancedReports",
    title: "Cobranza avanzada",
    bullets: [
      "Selección masiva de pacientes",
      "Exportación operativa de cobranza",
      "Saldo a favor y aging ampliado",
      "Herramientas más fuertes de seguimiento"
    ]
  },
  executiveDashboard: {
    requiredPlan: "PRO",
    planFlag: "allowExecutiveDashboard",
    title: "Dashboard ejecutivo ampliado",
    bullets: [
      "Lectura gerencial del negocio",
      "Salud operativa y financiera del día",
      "Indicadores premium de seguimiento"
    ]
  },
  aiTools: {
    requiredPlan: "PRO",
    planFlag: "allowAI",
    title: "Centro inteligente",
    bullets: [
      "Autofill inteligente",
      "Redistribución operativa",
      "Alertas automáticas",
      "Predicción y acciones IA"
    ]
  },
  audit: {
    requiredPlan: "PRO",
    planFlag: "allowAudit",
    title: "Auditoría",
    bullets: [
      "Alertas de diferencias",
      "Control por usuario",
      "Control por clínica",
      "Seguimiento de cierre de caja"
    ]
  },
  multiClinic: {
    requiredPlan: "ENTERPRISE",
    planFlag: "allowMultiClinic",
    title: "Vista multi-clínica",
    bullets: [
      "Comparativo entre clínicas",
      "Semáforo por sede",
      "Lectura consolidada del negocio"
    ]
  }
}

export function getPlanLabel(planCode) {
  return PLAN_LABELS[planCode] || planCode || "Plan superior"
}

export function getFeatureConfig(featureKey) {
  return FEATURE_REQUIREMENTS[featureKey] || null
}

export function getFeatureRequiredPlan(featureKey) {
  return FEATURE_REQUIREMENTS[featureKey]?.requiredPlan || null
}

export function resolveRequiredPlanFromPlans(featureKey, plans = []) {
  const feature = FEATURE_REQUIREMENTS[featureKey]
  if (!feature?.planFlag) return feature?.requiredPlan || null

  const orderedPlans = [...plans].sort(
    (a, b) => Number(a.displayOrder || 0) - Number(b.displayOrder || 0)
  )

  const found = orderedPlans.find((plan) => Boolean(plan?.[feature.planFlag]))
  return found?.code || feature.requiredPlan || null
}